export default {
      id: "command__restore-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#command__restore",
      toString: function () {
        return this.url;
      }
    }